const existUsuario = (store) => {
  return new Promise((resolve, reject) => {
    store.dispatch('user/getUser')
      .then(() => resolve(store.state.user.notExists))
      .catch(() => reject(true))
  })
}

const initApp = async (store) => {
  if (store.state.initApp) {
    return Promise.resolve(true);
  }
  store.dispatch('setInitApp', false)

  const noexiste = await existUsuario(store)
  if (noexiste) {
    store.dispatch('setInitApp', true)
    return Promise.resolve(false)
  }

  return new Promise((resolve, reject) => {
    const roles = store.dispatch('roles/getRoles')
    const parametros = store.dispatch('parametro/getParametros')
    const menus = store.dispatch('menus/getMenus')

    return Promise.all([roles, parametros, menus])
      .then(() => {
        store.dispatch('setInitApp', true)
        resolve(true)
      })
      .catch(() => {
        store.dispatch('setInitApp', true)
        reject(false)
      })
  })
}

export const appConfig = {
  initApp
}
